import React from 'react';
import Header from './Header';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthentication } from '../../hooks/useAuthentication';

const HeaderContainer = () => {
  const { logout, userInfo, getRedirectUrl } = useAuthentication();

  const history = useNavigate();
  const { i18n } = useTranslation();

  const handleHomeClick = () => {
    history(`/${i18n.language}/`, { replace: true });
  };

  const logoutUser = () => {
    logout();
  };

  return (
    <Header
      t={i18n.t}
      language={i18n.language}
      user={userInfo}
      onHomeClick={handleHomeClick}
      logout={logoutUser}
      login={getRedirectUrl}
    />
  );
};

export default React.memo(HeaderContainer);
